import React from "react";
import { Link } from "gatsby";
import { useTranslation } from "react-i18next";
import * as styles from "./home-about.module.scss";

export const HomeAbout = () => {
  const { t } = useTranslation();

  return (
    <section className={styles.about}>
      <div className={styles.about__wrapp}>
        <div className={styles.about__text}>
          <h1 className={styles.about__title}>{t("home_about.title")}</h1>
          <p className={styles.about__descript}>
            {t("home_about.description")}
          </p>
          <Link to="/about-us" className={styles.menu__cardsButton}>
            {t("home_about.button")}
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.16602 10.0003H15.8327M15.8327 10.0003L12.4993 13.3337M15.8327 10.0003L12.4993 6.66699"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Link>
        </div>

        <div className={styles.about__img}>
          <img src="/images/home-page/home_about.webp" alt="Sushi" />
        </div>
      </div>
    </section>
  );
};
